<template>
  <div>
    <fieldset class="border p-3">
      <legend >
        <small style="font-size:15px; font-weight: bold">permission</small>
      </legend>
      <div>
        <form @submit.prevent="newPermission()">
          <div class="form-group">
            <label>permission name</label>
            <input type="text" class="form-control permissionname" placeholder="permission name" required />
          </div>
          
          <button type="submit" class="btn btn-primary btn-flat creatingPermission">
            <i class="fa fa-plus"></i> create permission
          </button>
          <button type="button" class="btn btn-info btn-flat creatingPermissionLoader">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(["newPermission"])
  }
};
</script>
<style scoped>
.creatingPermissionLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/permissions/permission.vue